import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { WithPageWrapper } from '@/pages/components/Branding';
import { PageWrapper } from '@/pages/components/Branding.styles';
import Calendar from '../components/Calendar';
import { PreScreeningFormShort } from './PreScreeningFormShort';

export const PreScreeningFormShortPage = ({ pageWrapper = true }) => {
  const [searchParams] = useSearchParams();
  const [emailAddress, setEmailAddress] = useState('');

  const showCalendar = Boolean(searchParams.get('cal'));

  useEffect(() => {
    const stored = localStorage.getItem('prescreeningUserEmail');
    if (stored) {
      setEmailAddress(stored);
    }
  }, []);

  if (showCalendar) {
    return (
      <PageWrapper>
        <Calendar showCalendar emailAddress={emailAddress} />
      </PageWrapper>
    );
  }

  return WithPageWrapper(<PreScreeningFormShort />, pageWrapper);
};
